import ElementSetting from '@/components/sections/builder/elements/body/checkout-form/setting';
import ElementContent from '@/components/sections/builder/elements/body/checkout-form/content';
import { CheckoutFormElemetDataType } from '@/components/sections/builder/elements/body/checkout-form/type';
import { FileText } from 'lucide-react';

const defaultData: CheckoutFormElemetDataType = {
  name: 'Checkout Form',
  columns: 2,
  layoutPosition: 'left',
  radiusCheckoutItem: 0,
  stickyContent: false,
  topContent: 0,
  labelButtonPayNow: 'Pay Now',
  labelContinueShopping: 'Continue shopping',
};

export const ElementPreviewIcon = FileText;

const CheckoutForm = {
  type: 'checkout_form',
  group: 'body_checkout',
  defaultData,
  PreviewIcon: ElementPreviewIcon,
  Element: ElementContent,
  Setting: ElementSetting,
  defaultChilds: [],
  childs: [],
  maxEntries: 1,
  isImmutable: true,
};

export default CheckoutForm;
